<template>
  <li class="menu-item pagination" :data-active="$store.getters.drawMode !== 'hide'" >
    <a href="#" @click.prevent="toggleMode" :title="drawMode === 'hide' ? 'Vis tegninger' : 'Skjul tegninger'" :class="drawMode === 'draw' ? 'active' : ''">
      <t-icon :name="iconName" />
    </a>
    <div class="page-number">{{ pageNumberDisplay }}</div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions(['setDrawMode']),
    toggleMode () {
      if (this.drawMode === 'hide') {
        this.setDrawMode('view')
      } else {
        this.setDrawMode('hide')
      }
    }
  },
  computed: {
    ...mapGetters(['drawMode']),
    spread () {
      return this.$store.getters.spread
    },
    iconName () {
      if (this.spread) {
        const even = this.$store.getters.evenPageHasElements
        const odd = this.$store.getters.oddPageHasElements
        if (even && odd) {
          return 'icon-spread-selcted-both'
        } else if (even && !odd) {
          return 'icon-spread-selcted-left'
        } else if (!even && odd) {
          return 'icon-spread-selcted-right'
        } else {
          return 'icon-spread'
        }
      } else {
        return 'icon-page-left'
      }
    },
    evenPage () {
      return this.$store.getters.evenPage || null
    },
    oddPage () {
      return this.$store.getters.oddPage || null
    },
    pageNumberDisplay () {
      if (this.spread) {
        return `${this.evenPage !== null || this.evenPage === undefined ? this.evenPage.pageNumber : ''} - ${this.oddPage !== null || this.oddPage === undefined ? this.oddPage.pageNumber : ''}`
      } else {
        return this.$store.getters.currentPageNumber
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "../style/variables" as *;

  .pagination {
    margin-top: 15px;
  }

    .pagination[data-active="true"] {
      a

  {
    color: $menu-item-hover-color;
  }

  }

  .pagination a {
    font-size: 25px;
    padding: 0;
  }

  .page-number {
    margin: 0 -5px;
    color: #FFF;
    font-size: 11px;
    text-align: center;
  }
</style>
